"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.AssetDualList = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _reselect = require("reselect");

var _commonDualList = _interopRequireDefault(require("./common-dual-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getAssetDisplay = function getAssetDisplay(_, props) {
  return props && {
    hideCoupledAssets: props.hideCoupledAssets,
    showHistoricalAssets: props.showHistoricalAssets
  };
};

var assetSelector = (0, _reselect.createSelector)(_nicbaseReducers.getAssetInfos, _nicbaseReducers.getCoupledAssetInfos, _nicbaseReducers.getHistoricalCoupledAssetInfos, getAssetDisplay, function (assets, coupledAssets, historicalCoupledAssets, assetDisplay) {
  var mergedAssets = assets || [];

  if (!assetDisplay.hideCoupledAssets) {
    if (assetDisplay.showHistoricalAssets) {
      mergedAssets = [].concat(_toConsumableArray(mergedAssets), _toConsumableArray(historicalCoupledAssets));
    } else {
      mergedAssets = [].concat(_toConsumableArray(mergedAssets), _toConsumableArray(coupledAssets));
    }
  }

  return mergedAssets.reduce(function (result, _ref) {
    var id = _ref.id,
        name = _ref.name;
    result.push({
      id: id,
      label: name
    });
    return result;
  }, []);
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var mappedProps = {
    assets: assetSelector(state, ownProps)
  };

  if (ownProps.useAssetsInParams) {
    mappedProps.assets = ownProps.assets.map(function (asset) {
      return {
        id: asset.id,
        label: asset.name
      };
    });
  }

  return mappedProps;
};

exports.mapStateToProps = mapStateToProps;

var AssetDualList = function AssetDualList(_ref2) {
  var assets = _ref2.assets,
      selectedAssets = _ref2.selectedAssets,
      allAssetsSelected = _ref2.allAssetsSelected,
      _onChange = _ref2.onChange;
  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Asset, null),
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "duallist.assets",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_commonDualList["default"], {
    items: assets,
    allItemsSelected: allAssetsSelected,
    selectedItems: selectedAssets,
    onChange: function onChange(_ref3) {
      var allItemsSelected = _ref3.allItemsSelected,
          selectedItems = _ref3.selectedItems;
      return _onChange({
        allAssetsSelected: allItemsSelected,
        selectedAssets: selectedItems
      });
    }
  }));
};

exports.AssetDualList = AssetDualList;
AssetDualList.propTypes = {
  allAssetsSelected: _propTypes["default"].bool,
  assets: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  selectedAssets: _propTypes["default"].arrayOf(_propTypes["default"].number),
  onChange: _propTypes["default"].func
};
AssetDualList.defaultProps = {
  allAssetsSelected: true,
  assets: [],
  selectedAssets: [],
  onChange: function onChange() {}
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(AssetDualList);

exports["default"] = _default;